<template v-if="categoriesStore.showCategoryFilters">
    <div class="mb-1.5 border-b border-gray-300 pb-1.5">
        <h3 class="h6" v-if="categoriesStore.topLevelCategories.length > 1">
            By Type
        </h3>

        <div class="flex gap-x-2 gap-y-1 flex-wrap justify-center">
            <TopLevelCategories />
        </div>

            <h3 class="h6 border-gray-300"
                :class="categoriesStore.topLevelCategories.length > 1 ? 'pt-1.5 mt-1.5 border-t' : ''"
                v-if="categoriesStore.chosenTopLevelCategory || categoriesStore.topLevelCategories.length <= 1"
            >
                By Category
            </h3>
            <ul class="grid grid-cols-1 gap-half md:grid-cols-2">
                <template
                v-for="(category, index) in categoriesStore.categories"
            >
                    <li
                        class="flex items-center"
                        v-if="
                            categoriesStore.topLevelCategories.length <= 1
                            && !categoriesStore.chosenTopLevelCategory
                            || category.parentId === categoriesStore.chosenTopLevelCategory
                        "
                    >
                        <input
                            type="checkbox"
                            v-bind:id="category.id"
                            v-bind:value="category.id"
                            data-param="categories"
                            v-bind:data-parentid="category.parentId"
                            v-model="category.checked"
                            class="border-gray-500 mr-[0.5rem] w-1 h-1 text-primary cursor-pointer"
                            v-on:click="categoriesStore.setShowAllToFalse"
                        >
                        <label v-bind:for="category.id" class="cursor-pointer">{{category.title}}</label>
                    </li>
                </template>
            </ul>
        </div>

</template>
